export const clientTypes = ['All', 'Setup', 'Live', 'Inactive'];
